"use strict";
/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.policyBeet = exports.Policy = exports.policyDiscriminator = void 0;
const web3 = __importStar(require("@solana/web3.js"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
const DynamicRoyalty_1 = require("../types/DynamicRoyalty");
exports.policyDiscriminator = [222, 135, 7, 163, 235, 177, 33, 68];
/**
 * Holds the data for the {@link Policy} Account and provides de/serialization
 * functionality for that data
 *
 * @category Accounts
 * @category generated
 */
class Policy {
    constructor(version, bump /* size: 1 */, uuid, authority, dynamicRoyalty, jsonRule) {
        this.version = version;
        this.bump = bump;
        this.uuid = uuid;
        this.authority = authority;
        this.dynamicRoyalty = dynamicRoyalty;
        this.jsonRule = jsonRule;
    }
    /**
     * Creates a {@link Policy} instance from the provided args.
     */
    static fromArgs(args) {
        return new Policy(args.version, args.bump, args.uuid, args.authority, args.dynamicRoyalty, args.jsonRule);
    }
    /**
     * Deserializes the {@link Policy} from the data of the provided {@link web3.AccountInfo}.
     * @returns a tuple of the account data and the offset up to which the buffer was read to obtain it.
     */
    static fromAccountInfo(accountInfo, offset = 0) {
        return Policy.deserialize(accountInfo.data, offset);
    }
    /**
     * Retrieves the account info from the provided address and deserializes
     * the {@link Policy} from its data.
     *
     * @throws Error if no account info is found at the address or if deserialization fails
     */
    static async fromAccountAddress(connection, address) {
        const accountInfo = await connection.getAccountInfo(address);
        if (accountInfo == null) {
            throw new Error(`Unable to find Policy account at ${address}`);
        }
        return Policy.fromAccountInfo(accountInfo, 0)[0];
    }
    /**
     * Provides a {@link web3.Connection.getProgramAccounts} config builder,
     * to fetch accounts matching filters that can be specified via that builder.
     *
     * @param programId - the program that owns the accounts we are filtering
     */
    static gpaBuilder(programId = new web3.PublicKey('ocp4vWUzA2z2XMYJ3QhM9vWdyoyoQwAFJhRdVTbvo9E')) {
        return beetSolana.GpaBuilder.fromStruct(programId, exports.policyBeet);
    }
    /**
     * Deserializes the {@link Policy} from the provided data Buffer.
     * @returns a tuple of the account data and the offset up to which the buffer was read to obtain it.
     */
    static deserialize(buf, offset = 0) {
        return exports.policyBeet.deserialize(buf, offset);
    }
    /**
     * Serializes the {@link Policy} into a Buffer.
     * @returns a tuple of the created Buffer and the offset up to which the buffer was written to store it.
     */
    serialize() {
        return exports.policyBeet.serialize({
            accountDiscriminator: exports.policyDiscriminator,
            ...this,
        });
    }
    /**
     * Returns the byteSize of a {@link Buffer} holding the serialized data of
     * {@link Policy} for the provided args.
     *
     * @param args need to be provided since the byte size for this account
     * depends on them
     */
    static byteSize(args) {
        const instance = Policy.fromArgs(args);
        return exports.policyBeet.toFixedFromValue({
            accountDiscriminator: exports.policyDiscriminator,
            ...instance,
        }).byteSize;
    }
    /**
     * Fetches the minimum balance needed to exempt an account holding
     * {@link Policy} data from rent
     *
     * @param args need to be provided since the byte size for this account
     * depends on them
     * @param connection used to retrieve the rent exemption information
     */
    static async getMinimumBalanceForRentExemption(args, connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(Policy.byteSize(args), commitment);
    }
    /**
     * Returns a readable version of {@link Policy} properties
     * and can be used to convert to JSON and/or logging
     */
    pretty() {
        return {
            version: this.version,
            bump: this.bump,
            uuid: this.uuid.toBase58(),
            authority: this.authority.toBase58(),
            dynamicRoyalty: this.dynamicRoyalty,
            jsonRule: this.jsonRule,
        };
    }
}
exports.Policy = Policy;
/**
 * @category Accounts
 * @category generated
 */
exports.policyBeet = new beet.FixableBeetStruct([
    ['accountDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['version', beet.u8],
    ['bump', beet.uniformFixedSizeArray(beet.u8, 1)],
    ['uuid', beetSolana.publicKey],
    ['authority', beetSolana.publicKey],
    ['dynamicRoyalty', beet.coption(DynamicRoyalty_1.dynamicRoyaltyBeet)],
    ['jsonRule', beet.coption(beet.utf8String)],
], Policy.fromArgs, 'Policy');
//# sourceMappingURL=data:application/json;base64,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